import axios from 'axios';
import { apiBaseUrl } from '../config';

const opts = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
  withCredentials: true,
});

/**
 * Fetch OHLCV bars for a symbol (historical daily bars).
 */
export const getOhlcv = (token, symbol, period = '6mo', interval = '1d') =>
  axios.get(`${apiBaseUrl}/marketdata/history/${symbol}`, {
    ...opts(token),
    params: { period, interval },
  });

/**
 * Fetch latest quotes for a list of symbols.
 */
export const getQuotes = (token, symbols = []) =>
  axios.get(`${apiBaseUrl}/marketdata/quotes`, {
    ...opts(token),
    params: { symbols: symbols.join(',') },
  });

/**
 * Browse available active stocks (with optional search query).
 */
export const listStocks = (token, search = '') =>
  axios.get(`${apiBaseUrl}/papertrading/stocks`, {
    ...opts(token),
    params: search ? { search } : {},
  });

/**
 * Public index quotes for the site-wide ticker bar.
 *
 * Deliberately unauthenticated: TickerBar renders on marketing pages for
 * logged-out visitors. Served from a short server-side cache, so landing-page
 * traffic cannot translate into upstream provider load.
 */
export const getIndices = () => axios.get(`${apiBaseUrl}/marketdata/indices`);
